import React from "react";
import PropTypes from "prop-types";
import axios from "axios";

import Signature from "../../Signature";

class SignatureSection extends React.Component {
  handleSignature = (dataImage, clear) => {
    if (clear) {
      return;
    }

    const { signature, onDone } = this.props;
    const data = {
      signature_attributes: {
        id: signature && signature.id,
        data_image: dataImage,
        _destroy: !!(signature && signature.id) && !dataImage
      }
    };

    axios.put(`${window.location.pathname}/employees/signature`, data)
      .then(({ data }) => {
        onDone({ id: data.id, data_image: dataImage });
      });
  };

  render() {
    const { signature } = this.props;

    return (
      <div className="well shadowDepth1 information">
        <h3 className="text-center">Signature</h3>

        <Signature
          title="Please sign in"
          signature={signature && signature.data_image}
          onDone={this.handleSignature}
        >
          <div className="text-center">
            <span className="btn btn-text">
              Click here to sign in 
            </span>
          </div>
        </Signature>
      </div>
    );
  }
}

SignatureSection.propTypes = {
  signature: PropTypes.objectOf(PropTypes.any),
  onDone: PropTypes.func
};

SignatureSection.defaultProps = {
  signature: {},
  onDone: () => {}
};

export default SignatureSection;
